<div style="text-align: left;">
    <div class="banner center" style="max-width: 500px;">
        <div class="row" style="justify-content: center;">
            <div class="col-md-12">
                <h5>Clone Business</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label>Business Code :</label>
            </div>
            <div class="col-md-6">
                <input type="number" [(ngModel)]="businessCode" maxlength="10" style="text-align: left;" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label>Business PIN :</label>
            </div>
            <div class="col-md-6">
                <input type="number" [(ngModel)]="businessPin" maxlength="6" style="text-align: left;" />
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="text-align: center;">
                <button style="margin-top: 10px;" class="btn btn-primary" (click)="onAuthenticate()">Authenticate
                    Business</button>
            </div>
        </div>
    </div>
    <div class="banner center" style="max-width: 500px;margin-top: 10px;" *ngIf="fromBusinessName">
        <div class="row">
            <div class="col-md-6">
                <label>From Business Name :</label>
            </div>
            <div class="col-md-6">
                <span>{{ fromBusinessName }}</span>
            </div>
        </div>
        <div class="box">
            <h5 style="text-align: center;">Include to Clone</h5>
            <div *ngFor="let item of cloneOptions">
                <label style="font-weight: normal; margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="item.isSelected" />
                    <span class="normal_color">{{item.value}}</span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label>New Business Name :</label>
            </div>
            <div class="col-md-6">
                <input type="text" [(ngModel)]="newBusinessName" style="text-align: left;" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label>New Business Address :</label>
            </div>
            <div class="col-md-6">
                <textarea type="text" rows="3" [(ngModel)]="newBusinessAddress" style="text-align: left;"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="text-align: center;">
                <button style="margin-top: 10px;" class="btn btn-primary" (click)="onClone()">Clone Business</button>
            </div>
        </div>
    </div>
</div>